<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo15bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 68px; top: 50px">
      <p>Mira el dibujo y lee la palabra.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 87px">
      <p>Marca cada sílaba con un golpe.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 125px">
      <p>
        Pinta tantos círculos como sílabas<br />
        tiene la palabra.
      </p>
    </span>

    <label
      class="checkMarkContainer-a pageElement"
      style="left: 291px; top: 572.12px; position: absolute"
      >Una Sílaba
      <input type="checkbox" 
      ref="1" 
      v-on:click="saveOption('silabasSapo', 1)" 
      :onload="loadOption('silabasSapo', 1)"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a pageElement"
      style="left: 355px; top: 572.12px; position: absolute"
      >Dos Sílabas
      <input type="checkbox" 
      ref="2" 
      v-on:click="saveOption('silabasSapo', 2)" 
      :onload="loadOption('silabasSapo', 2)"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a pageElement"
      style="left: 418px; top: 572.12px; position: absolute"
      >Tres Sílabas
      <input type="checkbox" 
      ref="3" 
      v-on:click="saveOption('silabasSapo', 3)" 
      :onload="loadOption('silabasSapo', 3)"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a pageElement"
      style="left: 481px; top: 572.12px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox" 
      ref="4" 
      v-on:click="saveOption('silabasSapo', 4)" 
      :onload="loadOption('silabasSapo', 4)"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a pageElement"
      style="left: 544px; top: 572.12px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox" 
      ref="5" 
      v-on:click="saveOption('silabasSapo', 5)" 
      :onload="loadOption('silabasSapo', 5)"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a pageElement"
      style="left: 608px; top: 572.12px; position: absolute"
      >Seis Sílabas
      <input type="checkbox" 
      ref="6" 
      v-on:click="saveOption('silabasSapo', 6)" 
      :onload="loadOption('silabasSapo', 6)"
      >
      <span class="checkmark-a"></span>
    </label>

    <div class="text-box-a pageElement hover-animation-a" id="textBoxGroup">
      <img id="textBoxSVG" src="/pages/img/sordo/svgPage68TextBox.svg" />
      <p class="textBase" id="text05">
        Luego, en cada cartel,<br />
        escribe otra palabra que<br />
        tenga la misma cantidad<br />
        de sílabas.
      </p>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <img
      id="tortoise"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo8TortoiseFlip.svg"
    />
    <img
      id="toad"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo11Toad.svg"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 45px;
  top: 264px;
}
#inputField01 {
  position: absolute;
  width: 160px;
  height: 50px;
  left: 745px;
  top: 580px;
  background-color: #d2d1c2;
}
#tortoise {
  position: absolute;
  left: 45px;
  top: 283px;
}
#toad {
  position: absolute;
  width: 195px;
  left: 70px;
  top: 525px;
}
#textBoxGroup {
  position: absolute;
  width: 393.37px;
  height: 302.28px;
  left: 608px;
  top: 26px;
}
#textBoxSVG {
  position: absolute;
  width: 393.37px;
  height: 302.28px;
  left: 0px;
  top: 0px;
}
#text05 
{
position: absolute;
width: 325px;
height: 164px;
left: 27px;
top: 10px;
font-weight: 600;
font-size: 26px;
line-height: 35px;
text-align: center;
color: #FFFFFF;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>
